import { FormField } from '@/types/forms/fields/formField';
import { TextField } from '@/types/forms/fields/textField';
import { FormElement, FormElementConfig } from '@/types/forms/formElement';
import { FormGroup } from '@/types/forms/formGroup';
import { ActivePowerAndApparentPowerFormGroup } from '../activePowerAndApparentPowerFormGroup';
import { ManufacturerAndModuleTypeFormGroup } from '../manufacturerAndModuleTypeFormGroup';
import { QuantityAndGeneratorTypeFormGroup } from '../quantityAndGeneratorTypeFormGroup';
import { ReferenceFormGroup } from '../../referenceFormGroup';
import { ZerezIdAndNormFormGroup } from '../zerezIdAndNormFormGroup';
import { CheckboxField } from '@/types/forms/fields/checkboxField';

export type GeneratorModuleFormGroupConfig = FormElementConfig &
    Omit<GeneratorModuleFormGroup, keyof FormGroup>;

export class GeneratorModuleFormGroup extends ReferenceFormGroup {
    public readonly generatorManufacturerAndModuleType: ManufacturerAndModuleTypeFormGroup;
    public readonly generatorZerezIdAndNorm: ZerezIdAndNormFormGroup;
    public readonly generatorManualInputManufacturerTypeZerezId: CheckboxField;
    public readonly unitCertificateInvalidForInstalledPower: FormElement;
    public readonly generatorQuantityAndGeneratorType: QuantityAndGeneratorTypeFormGroup;
    public readonly generatorActivePowerAndApparentPower: ActivePowerAndApparentPowerFormGroup;
    public readonly generatorTotalActivePowerIsGreaterThanTotalApparentPowerWarning: FormElement;
    public readonly generatorTotalActivePower: FormField<number>;
    public readonly generatorTotalApparentPower: FormField<number>;

    constructor(config: GeneratorModuleFormGroupConfig) {
        super(config);

        this.generatorManufacturerAndModuleType =
            config.generatorManufacturerAndModuleType;
        this.generatorZerezIdAndNorm = config.generatorZerezIdAndNorm;
        this.generatorManualInputManufacturerTypeZerezId =
            config.generatorManualInputManufacturerTypeZerezId;
        this.unitCertificateInvalidForInstalledPower =
            config.unitCertificateInvalidForInstalledPower;
        this.generatorQuantityAndGeneratorType =
            config.generatorQuantityAndGeneratorType;
        this.generatorActivePowerAndApparentPower =
            config.generatorActivePowerAndApparentPower;
        this.generatorTotalActivePowerIsGreaterThanTotalApparentPowerWarning =
            config.generatorTotalActivePowerIsGreaterThanTotalApparentPowerWarning;
        this.generatorTotalActivePower = config.generatorTotalActivePower;
        this.generatorTotalApparentPower = config.generatorTotalApparentPower;
    }
}
